import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";
import AppRouter from "./routes/AppRouter";
import "./styles/general.css";
import "./styles/palette.css";
import "./styles/text.css";
import "./styles/variables.css";

/* const Home = lazy(() => import("./screens/Home/Home"));
const CrearGrilla = lazy(() => import("./screens/CrearGrilla/CrearGrilla"));
const DocentesSearch = lazy(() =>
  import("./screens/Docentes/DocentesSearch/DocentesSearch")
);
const DocentesEdit = lazy(() =>
  import("./screens/Docentes/DocentesEdit/DocentesEdit")
); */

function App() {
  const location = useLocation();
  const props = location.state?.props ?? {};

  // oculta los componentes del en caso de que sea el visor pdf
  const isVisorPdf = location.pathname.startsWith("/visor-pdf");

  return (
    <>
      {!isVisorPdf && <Header />}
      <ToastContainer position="bottom-right" hideProgressBar />
      <AppRouter />
      {!isVisorPdf && <Footer />}
    </>
  );
}

export default App;
